<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            v-if="$route.name === 'qualitysmile'"
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
          <ion-button v-else @click="modalController.dismiss()">
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="start"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <Header
          class="u-bg-orange -contain-bottom"
          headline="Ihr Partner für Zahnversorgungen und Zahnersatz – deutschlandweit"
          :image="require('@/assets/img/home/icon_zahnarzt_iso.svg')"
          :logo="require('@/assets/img/qualitysmile_logo.png')"
          logoWidth="130"
          hideButton
        />
        <p class="ion-padding-top ion-hide-lg-up">
          <b
            >Ihr Partner für Zahnversorgungen und Zahnersatz –
            deutschlandweit</b
          >
        </p>
        <p>
          Mit Quality Smile finden Sie zahntechnische Labore für Ihre
          Zahnversorgung.
        </p>
        <p>
          Unser Partner unterstützt Sie gerne bei der Suche. Individuell auf
          Ihre Bedürfnisse abgestimmt, erhalten Sie aus dem Quality Smile
          Netzwerk Empfehlungen zu Zahnersatzversorgungen.
        </p>
        <p>
          Sollten Sie die Behandlung von Ihrem Zahnarzt durchführen lassen
          wollen, prüft Quality Smile gerne den Kostenvoranschlag für Sie und
          erstellt auf Wunsch auch einen Kostenvoranschlag für Sie.
        </p>
        <ion-row class="ion-margin-bottom" v-if="from !== 'chat'">
          <ion-col size="6">
            <div
              class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
              style="height:100%; cursor: pointer; padding: 16px 8px 16px 8px;"
              @click="openCallQualitySmileModal()"
            >
              <ion-icon
                style="font-size: 32px; margin-bottom: 10px"
                :icon="call"
                slot="start"
              ></ion-icon>
              <br />
              Gebührenfrei anrufen
            </div>
          </ion-col>
          <ion-col size="6">
            <div
              class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
              style="height:100%; cursor: pointer; padding: 16px 8px 16px 8px;"
              @click="
                $router.push({
                  name: 'home',
                  params: {
                    shouldShowDentistSearch: true,
                    from: 'qualitySmile',
                  },
                })
              "
            >
              <ion-icon
                style="font-size: 32px; margin-bottom: 10px"
                :src="require('@lib/assets/icons/roodie-white_orange.svg')"
                slot="start"
              ></ion-icon>
              <br />
              Roodie.Check starten
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  modalController,
  IonRow,
  IonCol,
  IonBackButton,
} from "@ionic/vue";
import Header from "@/components/Header";
import CallQualitySmileModal from "@arag/components/CallQualitySmileModal";
import { call } from "ionicons/icons";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    Header,
    IonRow,
    IonCol,
    IonBackButton,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openCallQualitySmileModal() {
      const modal = await modalController.create({
        component: CallQualitySmileModal,
        cssClass: "c-autoheight-modal",
      });
      return modal.present();
    },
  },
  setup() {
    return {
      modalController,
      call,
    };
  },
};
</script>

<style lang="scss" scoped></style>
